<template>
	<div>
		<a-spin :spinning="formLoading">
			<a-tabs :activeKey="activeKey" @change="handleActiveKeyChange" class="tab-container">
				<a-tab-pane tab="基础设置" key="info" class="tab-pane">
					<InfoForm
						ref="infoRef"
						:activeKey="activeKey"
						:is-detail="isDetail"
						:propFormData="formData"
						@update:activeKey="handleActiveKeyChange"
					/>
				</a-tab-pane>
				<a-tab-pane tab="价格库存" key="price" class="tab-pane">
					<PriceForm
						ref="priceRef"
						:activeKey="activeKey"
						:is-detail="isDetail"
						:propFormData="formData"
						@update:activeKey="handleActiveKeyChange"
					/>
				</a-tab-pane>
				<a-tab-pane tab="商品详情" key="description" class="tab-pane">
					<DescriptionForm
						ref="descriptionRef"
						:activeKey="activeKey"
						:is-detail="isDetail"
						:propFormData="formData"
						@update:activeKey="handleActiveKeyChange"
					/>
				</a-tab-pane>
			</a-tabs>
			<a-form>
				<a-form-item style="float: right">
					<a-button v-if="!isDetail" :loading="formLoading" type="primary" @click="submitForm">
						保存
					</a-button>
					<a-button @click="close">返回</a-button>
				</a-form-item>
			</a-form>
		</a-spin>
	</div>
</template>

<script>
import InfoForm from './InfoForm.vue'
import DescriptionForm from './DescriptionForm.vue'
import PriceForm from './PriceForm.vue'
import { floatToFixed2, formatToFraction, convertToInteger } from "@/utils/index.js";
export default {
	name: 'ProductMallForm',
	components: {
		InfoForm,
		DescriptionForm,
		PriceForm,
	},
	props: {
		id: {
			type: Number,
			default: null
		}
	},
	data() {
		return {
			// 表单的加载中：1）修改时的数据加载；2）提交的按钮禁用
			formLoading: false,
			// Tag 激活的窗口
			activeKey: 'info',
			// 是否查看详情
			isDetail: false,
				// 商品信息 Ref
			infoRef: null,
			// 商品详情 Ref
			descriptionRef: null,
			// SPU 表单数据
			formData: {
				name: '', // 商品名称
				facilitatorId: undefined, // 服务商
				productCategoryId: undefined, // 商品分类
				keyword: '', // 关键字
				picUrl: '', // 商品封面图
				sliderPicUrls: '', // 商品轮播图
				introduction: '', // 商品简介
				priceList: [
					{
						price: 0, // 商品价格
						marketPrice: 0, // 市场价
						costPrice: 0, // 成本价
						barCode: '', // 商品条码
						picUrl: '', // 图片地址
						stock: 0, // 库存
					}
				],
				description: '', // 商品详情
				sort: 0, // 商品排序
				virtualSalesCount: 0, // 虚拟销量
				productMallState: 3, // 商品状态 2-下架，3-上架
				isTop:2, // 首页显示状态 3=是，2=否
			}
		}
	},

	created() {
		this.getDetail()
	},
	methods: {
		/** 获得详情 */
		async getDetail() {
			const id = this.id
			if (id) {
				this.formLoading = true
				try {
					const{data: res} = await this.$http.post(this.navigation.apiProductMallDetail+ '/' + id)
					this.formData = res.data
					this.formData.priceList?.forEach((item) => {
						if (this.isDetail) {
							item.price = floatToFixed2(item.price)
							item.marketPrice = floatToFixed2(item.marketPrice)
							item.costPrice = floatToFixed2(item.costPrice)
						} else {
							// 回显价格分转元
							item.price = formatToFraction(item.price)
							item.marketPrice = formatToFraction(item.marketPrice)
							item.costPrice = formatToFraction(item.costPrice)
						}
					})
					
					
				} finally {
					this.formLoading = false
				}
			}
		},
		
		/** 处理activeKey变化 */
		handleActiveKeyChange(value) {
			this.activeKey = value
		},
		
		/** 提交按钮 */
		async submitForm() {
			// 提交请求
			this.formLoading = true
			try {
				// 校验各表单
				await this.$refs.infoRef?.validate()
			
				await this.$refs.priceRef?.validate()
			
				await this.$refs.descriptionRef?.validate()
				
				// 深拷贝一份, 这样最终 server 端不满足，不需要影响原始数据
				const deepCopyFormData = JSON.parse(JSON.stringify(this.formData))
				
				deepCopyFormData.priceList.forEach((item) => {
					// 给sku name赋值
					item.name = deepCopyFormData.name
					// price 相关价格元转分
					item.price = convertToInteger(item.price)
					item.marketPrice = convertToInteger(item.marketPrice)
					item.costPrice = convertToInteger(item.costPrice)
					item.firstBrokeragePrice = convertToInteger(item.firstBrokeragePrice)
					item.secondBrokeragePrice = convertToInteger(item.secondBrokeragePrice)
				})
				
				// 校验都通过后提交表单
				const data = deepCopyFormData
				const id = this.id
				if (!id) {
					await this.apiProductMallAdd(data)
				} else {
					await this.apiProductMallEdit(data)
				}
				
				// this.close()
			} finally {
				this.formLoading = false
			}
		},

		async apiProductMallAdd(data) {
			try {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiProductMallAdd, data);
				if (res.code == 200) {
					this.$emit('close')
					this.$message.success(res.msg)
				} else {
					this.$message.error(res.msg)
				}
			} catch (error) {
				this.$message.error(error.message)
			}
		},

		async apiProductMallEdit(data) {
			try {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiProductMallEdit, data);
				if (res.code == 200) {
					this.$emit('close')
					this.$message.success(res.msg)
				} else {
					this.$message.error(res.msg)
				}
			} catch (error) {
				this.$message.error(error.message)
			}
		},
		
		/** 关闭按钮 */
		close() {
			this.$emit('close')
		}
	}
}
</script>
<style scoped lang="less">
.tab-container .tab-pane{
  height: calc(100vh - 210px);
  overflow-y: auto;
}


</style>
